import { isColor } from "../types";
import type { Color } from "../types";
import type { ColorStringParser } from "./ColorStringParser";

/**
 * RGBA color string parser. Parses color string in rgb(R, G, B) and rgba(R, G, B, A) formats.
 * @example "rgb(100%, 50%, 25%)", "rgba(255, 127, 63, .5)"
 */
export class RgbaColorStringParser implements ColorStringParser {
  /**
   * @inheritDoc
   */
  parse(colorString: string, quantumRange = 255): Color | undefined {
    if (!/^\s*rgba?/.test(colorString)) {
      return;
    }

    const match = colorString
      .replace(/\s/g, "")
      .match(/(\d+(\.\d+)?%?)|(\.\d+%?)/g);

    if (!match || match.length < 3) {
      return;
    }

    if (match.length === 3) {
      match.push("1");
    }

    const color = match
      .map((channel, index) => {
        const num = parseFloat(channel);
        if (index === 3) {
          // alpha channel value should be between 0 and 1
          return Math.round(num * quantumRange);
        }
        if (channel.indexOf("%") !== -1) {
          return Math.round((num / 100) * quantumRange);
        }
        return Math.round((num / 255) * quantumRange);
      })
      .filter((n) => !isNaN(n));

    if (isColor(color)) {
      return color;
    }
  }
}
